import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Pagination from "edu_lms_v2/components/Pagination";
import useScrollToTop from "edu_lms_v2/services/useScrollToTop";
import * as types from "edu_lms/constants/type";
import Styles from "./News.module.scss";
import { data_news } from "edu_lms_v2/data/data_news";
import Contact from "../DetailTraining/Contact";

export default function News() {
  useScrollToTop();
  const _ = require("lodash");
  const [data, setData] = useState([]);
  const [dataManyNews, setDataManyNews] = useState([]);
  const currentPage = useSelector(
    (state) => state.teachingReducer.currentPageClassroom
  );

  useEffect(() => {
    let dataTraining = _.filter(data_news, { categoryId: "tin-tuc" });
    let manyViews = _.orderBy(dataTraining, ["viewers"], ["desc"]);
    setData(dataTraining);
    setDataManyNews(manyViews.slice(0, 4));
  }, []);

  return (
    <main>
      <div className="hoc10-breadcrumb bg-gr">
        <div className="container">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Hỗ trợ</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Tin tức
            </li>
          </ul>
        </div>
      </div>
      <div className="hoc10-title bg-gr">
        <div className="container">
          <div className="header decor-h1 pr">
            <h1 className="title mb-10">Tin tức</h1>
            <p>Những tin tức cập nhật từ Hoc10</p>
          </div>
        </div>
      </div>
      <div className="hoc10-news">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <div className="post-list">
                <ViewAllName classNameName="">Tên bài viết</ViewAllName>
                {data.map((item, index) => (
                  <article className="post post-ty2 flex" key={index}>
                    <Link to="" title="">
                      <img src={item?.img} />
                    </Link>
                    <div className="post__content">
                      <h3>
                        <Link to="">{item?.title}</Link>
                      </h3>
                      <p className={`line line2 ${Styles.text_hidden}`}>
                        {item?.content}
                      </p>
                      <div className="flex-lc">
                        <div className="time flex-lc">
                          <i className="icon icon-time"></i> {item?.time}
                        </div>
                        <div className="view flex-lc">
                          <i className="icon icon-view"></i> {item?.viewers}
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
              <Pagination
                total={2}
                totalPerPage={types.TOTAL_CLASSROOM_PER_PAGE}
                currentPage={currentPage}
              />
            </div>
            <div className="col-lg-4 col-md-5">
              <div className="sidebar">
                <div className="readmany">
                  <h4>Nhiều người đọc</h4>

                  {dataManyNews.map((item, index) => (
                    <article className="post post-ty3 flex pr" key={index}>
                      <Link to="" className="post__thumb">
                        <img src={item?.img} className="fit" alt="" />
                      </Link>
                      <div className="post__content">
                        <h3 className="line line3">
                          <Link to="">{item?.content}</Link>
                        </h3>
                      </div>
                    </article>
                  ))}
                </div>
                <div className="email-register">
                  <h4>Đăng ký trải nghiệm đầy đủ tính năng Hoc10</h4>
                  <form action="" method="">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Nhập địa chỉ email"
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn-submit btn-pr flex-center"
                    >
                      Đăng ký ngay
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </main>
  );
}
const ViewAllName = styled.p`
  font-weight: 700;
  font: 24px/32px var(--SVN-GilroyBold);
  line-height: 22px;
  color: #4e4c50;
`;
